<template>
  <main class="page">
    <slot name="modal" />
    <section class="section">
      <div class="container">
        <div class="l-article">
          <div class="l-article-image">
            <figure class="image is-rounded is-square">
              <MediaImage
                v-if="media"
                :image="media.image"
                :image-style="articleDetail"
              />
            </figure>
            <div v-if="caption" class="caption">
              <span class="copyright">© {{ caption }}</span>
            </div>
          </div>
          <div class="l-article-title">
            <h1 class="title is-h1" v-html="title" />
          </div>

          <div class="l-article-meta">
            <slot name="meta" />
          </div>
          <div class="l-article-content">
            <div v-if="lead && lead" class="lead content" v-html="lead" />
            <hr v-if="!advertisement" class="is-primary" />
            <hr
              v-if="advertisement"
              class="hr-text"
              data-content="Publireportage"
            />
            <slot name="content">
              <div class="content" v-html="body" />
            </slot>
          </div>
        </div>
      </div>
    </section>
    <slot name="footer" />
  </main>
</template>

<script setup lang="ts">
import type { NodeArticleFragment } from '#graphql-operations'

defineProps<{
  title?: string
  lead?: string
  body?: string
  nid?: number
  caption?: string
  media?: NodeArticleFragment['media']
  advertisement?: NodeArticleFragment['advertisement']
}>()

const articleDetail = defineImageStyle({
  type: 'pictures',
  aspectRatio: 1,
  pictures: {
    xs: {
      width: 445,
      height: 445,
    },
  },
})
</script>

<style lang="scss">
.l-article {
  @include desktop {
    display: grid;
    grid-gap: $size-3;
    grid-template-columns: 2fr 3fr;
    grid-template-rows: auto auto 1fr;
  }
}

.l-article-image {
  grid-row: 1 / 3;
  grid-column: 1;
  margin-bottom: $size-4;
  @include tablet {
    float: right;
    width: 16rem;
    margin-left: 1.5rem;
  }
  @include desktop {
    width: auto;
    float: none;
    margin-bottom: 0;
    margin-left: 0;
  }
}

.l-article-content {
  grid-row: 2 / 4;
  grid-column: 2;
  margin-top: $size-3;
  @include tablet {
    margin-top: $size-4;
  }
  @include desktop {
    margin-top: 0;
  }
}

.l-article-title {
  grid-row: 1 / 2;
  grid-column: 2;
  margin-bottom: $size-3;
  @include desktop {
    margin-bottom: 0;
  }
}

.caption {
  font-size: $size-7;
  color: $grey-light;
  text-align: center;
  margin-top: 0.5rem;
}

.hr-text {
  background-color: $white;
  line-height: 1em;
  position: relative;
  outline: 0;
  border: 0;
  color: $yellow;
  text-align: center;
  font-size: $size-7;
  height: 1.5em;
  margin: 1.5rem 0 2rem;

  &:before {
    content: '';
    background: $yellow;
    position: absolute;
    left: 0;
    top: 50%;
    width: 100%;
    height: 2px;
  }

  &:after {
    content: attr(data-content);
    position: relative;
    display: inline-block;

    padding: 0 0.5em;
    line-height: 1.5em;
    color: $yellow;
    background-color: $white;
  }
}
</style>
